// extracted by mini-css-extract-plugin
module.exports = {"root":"Layout_root__20Ji6","wrap":"Layout_wrap__3aVms","sidebarOpen":"Layout_sidebarOpen__3ovFX","content":"Layout_content__2T71R"};